// Module
var code = `<div class="modal-header">
  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
  <h3>{{modal.title}}</h3>
</div>
<div class="modal-body">

  <div ng-bind-html="modal.body"></div>

</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" ng-click="dismiss()">Close</button>
</div>`;
// Exports
var _module_exports =code;;
var path = 'public/app/partials/modal.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;